import { useAddInConfig } from '@/_shared/hooks/add-in-config.js';
import { Spinner } from '@fluentui/react-components';
import { Navigate } from '@tanstack/react-router';

/**
 * The landing widget depends on the user: KSH users and brokers start on the
 * Schadenmanager, everyone else on the claim reporting page. The target is
 * therefore only known once the navigation config has been fetched; the Layout
 * guard around this route owns the loading and error states.
 */
export function IndexRedirect() {
    const { data } = useAddInConfig();

    if (!data) {
        return <Spinner size="large" />;
    }

    // The top level widget is itself a route (the Schadenmanager dashboard,
    // the claim reporting page); its children are sub pages of it.
    const widgetId = data.body.navigation[0]?.widgetId ?? 'dashboard';

    return <Navigate to={'/' + widgetId} replace />;
}
